/**
 * useAuth — wraps auth store with login/logout logic
 * Keeps components decoupled from the store implementation.
 */
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { loginApi, logoutApi } from '../api/authApi'
import { useUIStore } from '../store/uiStore'
import { ROUTES } from '../config/constants'

export function useAuth() {
  const { user, token, isAuthenticated, login, logout, hasRole } = useAuthStore()
  const addToast = useUIStore((s) => s.addToast)
  const navigate  = useNavigate()

  const handleLogin = useCallback(
    async (email, password) => {
      const userData = await loginApi(email, password)
      login(userData)
      addToast({ type: 'success', title: 'Welcome back!', message: `Signed in as ${userData.name}` })
      navigate(ROUTES.AUDIT_RUN, { replace: true })
    },
    [login, addToast, navigate]
  )

  const handleLogout = useCallback(async () => {
    try {
      await logoutApi()
    } finally {
      logout()
      navigate(ROUTES.LOGIN, { replace: true })
    }
  }, [logout, navigate])

  return {
    user,
    token,
    isAuthenticated,
    hasRole,
    login:  handleLogin,
    logout: handleLogout,
  }
}
